/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Ethnology16Inputs */

const en__field__enum_additionalstudyinterests_study_ethnology16 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Ethnology16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ethnology`)
};

const de__field__enum_additionalstudyinterests_study_ethnology16 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Ethnology16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ethnologie`)
};

/**
* | output |
* | --- |
* | "Ethnology" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Ethnology16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_ethnology16 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Ethnology16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Ethnology16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_ethnology16(inputs)
	return de__field__enum_additionalstudyinterests_study_ethnology16(inputs)
});
export { _field__enum_additionalstudyinterests_study_ethnology16 as "_field__enum_additionalStudyInterests_STUDY_ETHNOLOGY" }